module.exports = __webpack_public_path__ + "public/img/dataAnalyze.ab1bbebe.png";